import React from 'react';
import './SpecialGuests.css';

const guests = [
  {
    image: '/external/images/special guest/guest1.png',
    name: 'Dr. Om Prakash Pandey',
    description: 'A senior space scientist at ISRO and adviser on science and technology matters.'
  },
  {
    image: '/external/images/special guest/guest2.png',
    name: 'Prof. Indra Vardhan Trivedi',
    description: 'Vice-Chancellor of Mohanlal Sukhadiya University, Udaipur and Govind Guru University, Banswara.'
  },
  {
    image: '/external/images/special guest/guest3.png',
    name: 'Dr. Vidhyasagar Upadhyay',
    description: 'An international painter and fine art artist.'
  }
];

const SpecialGuests = () => {
  return (
    <section className="special-guests-section">
      <div className="special-guests-container">
        {guests.map((guest) => (
          <article className="special-guest" key={guest.name}>
            <img src={guest.image} alt={guest.name} />
            <div className="guest-info">
              <h3>{guest.name}</h3>
              <p>{guest.description}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default SpecialGuests;
